import {
  Center,
  ComboboxItem,
  Group,
  Select,
  SelectProps,
  Stack,
  Text
} from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { LabelWithHint } from '@/components/ui-shared/LabelWithHint/LabelWithHint'

const QOS_OPTIONS = [0, 1, 2]

export const QosSelect = (props: SelectProps) => {
  const intl = useIntl()

  return (
    <Select
      label={
        <LabelWithHint
          label={<FormattedMessage id="integrations.mqtt.broker.qos" />}
          hint={<FormattedMessage id="integrations.mqtt.broker.qos.hint" />}
        />
      }
      data={QOS_OPTIONS.map((qos) => ({
        value: String(qos),
        label: `${qos} (${intl.formatMessage({
          id: `integrations.mqtt.broker.qos.${qos}.label`
        })})`,
        description: intl.formatMessage({
          id: `integrations.mqtt.broker.qos.${qos}.description`
        })
      }))}
      allowDeselect={false}
      renderOption={({ option, checked }) => {
        const { label, description } = option as ComboboxItem & {
          description: string
        }

        return (
          <Group wrap="nowrap" align="start" gap="xs">
            <Center w={24} h={24}>
              {checked && <IconCheck size={16} />}
            </Center>

            <Stack gap={4}>
              <Text size="sm" fw={600}>
                {label}
              </Text>

              <Text size="xs">{description}</Text>
            </Stack>
          </Group>
        )
      }}
      {...props}
    />
  )
}
